import * as $ from 'jquery';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import {onClick, onSubmit} from 'Core/Events';
import {PlannerSubProcessCommon} from "Components/Planner/PlannerSubProcessCommon";

export class ServiceOpenPlannerProject extends PlannerSubProcessCommon {

    @onClick(PlannerSelectors.MODAL.BACK_TO_PROJECTS_BTN, ServiceOpenPlannerProject.loadAndDisplayUserProjectsModalAfterPageChange)
    @onClick(PlannerSelectors.MODAL.USER_PROJECTS_LIST.LOAD_PROJECT_BTN, ServiceOpenPlannerProject.displayPlannerProject)
    @onClick(PlannerSelectors.MODAL.USER_PROJECTS_LIST.DELETE_PROJECT_BTN, ServiceOpenPlannerProject.loadAndDisplayDeleteModal)
    @onClick(PlannerSelectors.MODAL.USER_PROJECTS_LIST.PAGE_BUTTONS, ServiceOpenPlannerProject.loadAndDisplayUserProjectsModalAfterPageChange)
    @onClick(PlannerSelectors.MODAL.CONFIRM_DELETE_PROJECT_BTN, ServiceOpenPlannerProject.deleteSelectedPlannerProject)
    @onSubmit(PlannerSelectors.MODAL.ASSIGN_PROJECT.FORM, ServiceOpenPlannerProject.assignPlannerProject)
    @onSubmit(PlannerSelectors.MODAL.FIND_PROJECTS.FORM, ServiceOpenPlannerProject.filterPlannerProjects)

    private static netDecor;

    public init(netDecor) {
        ServiceOpenPlannerProject.netDecor = netDecor;
        ServiceOpenPlannerProject.loadAndDisplayUserProjectsModal(1);
    }

    /**
     * Wczytuje i wyświetla modal z projektami usera
     */
    private static loadAndDisplayUserProjectsModal(page) {
        ServiceOpenPlannerProject.getAllUserPlannerProjects(page)
            .done((response) => {
                if (response.status == true) {
                    ServiceOpenPlannerProject.showModalWithAllUserProjects(response.html);
                } else {
                    if($(PlannerSelectors.TOOGLER).length > 0){
                        $(PlannerSelectors.TOOGLER).click();
                    } else {
                        ServiceOpenPlannerProject.loadAndDisplayModalSessionHasExpired();
                        ServiceOpenPlannerProject.emergencyLoadingOfLoginForm()
                            .done(() => {
                                $(PlannerSelectors.TOOGLER).click();
                            })
                    }
                }
            });
    }

    private static loadAndDisplayUserProjectsModalAfterPageChange(e)
    {
        e.preventDefault();
        let page = 1;
        if($(e.target).val().toString().length > 0){
            page = $(e.target).val() as number;
        }

        ServiceOpenPlannerProject.loadAndDisplayUserProjectsModal(page);
    }

    /**
     * Pokazuje modal z projektami usera
     */
    private static showModalWithAllUserProjects(html) {
        ServiceOpenPlannerProject.setSpinnerOnModal();
        ServiceOpenPlannerProject.modalOn();
        ServiceOpenPlannerProject.setContentOnModal(html)
    }

    private static assignPlannerProject(e) {
        e.preventDefault();
        let projectNumber = $(PlannerSelectors.MODAL.ASSIGN_PROJECT.NUMBER).val() as string;
        ServiceOpenPlannerProject.setSpinnerOnModal();
        if(projectNumber.length > 0) {
            ServiceOpenPlannerProject.assignPlannerProjectToAccount(projectNumber)
                .done((response) => {
                    ServiceOpenPlannerProject.showModalWithAllUserProjects(response.html);
                });
        }
    }


    /**
     * Wczytuje modal z projektami usera
     */
    private static getAllUserPlannerProjects(page) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}load_planner_projects/`,
            method: 'GET',
            data: {
                page: page
            },
            dataType: 'json',
        })
    }

    private static assignPlannerProjectToAccount(projectNumber) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}assign_project_to_account/`,
            method: 'GET',
            data: {
                projectNumber: projectNumber
            },
            dataType: 'json',
        })
    }

    /**
     * Wyśweitalnie projektu usera
     */
    private static displayPlannerProject(e) {
        let btn = $(e.target);
        let plannerProjectId = btn.data("planner-project-id");
        let projectData = null;
        ServiceOpenPlannerProject.getPlannerProjectData(plannerProjectId)
            .then(response => {
                projectData = response;
                return ServiceOpenPlannerProject.getPlannerProjectFile(response.project)
            })
            .then(response => {
                ServiceOpenPlannerProject.netDecor.Project.Open(new Uint8Array(response), JSON.stringify({id: projectData.id, name : projectData.projectName}));
            }).then(() => {
                ServiceOpenPlannerProject.modalOff();
        })
    }

    /**
     * Pobiera dane projektu
     */
    private static getPlannerProjectData(projectId) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}get_planner_project_data/`,
            method: 'POST',
            dataType: 'json',
            data: {
                id: projectId
            }
        })
    }

    /**
     * Pobiera plik projektu
     */
    private static getPlannerProjectFile(fileName) {
        var xhrOverride = new XMLHttpRequest();
        xhrOverride.responseType = 'arraybuffer';
        return $.ajax({
            url: window.location.origin + '/dekorator_projects/projects/'+fileName+'?'+Math.random(),
            method: 'GET',
            xhr: function() {
                return xhrOverride;
            }
        })
    }

    /**
     * Pobiera i wyświetla modal usuwanie projektu
     */
    private static loadAndDisplayDeleteModal(e) {
        ServiceOpenPlannerProject.setSpinnerOnModal();
        ServiceOpenPlannerProject.modalOn();
        let btn = $(e.target);
        let plannerProjectId = btn.data("planner-project-id");
        ServiceOpenPlannerProject.loadModalConfirmDeleteProject(plannerProjectId)
            .then((response) => {
                ServiceOpenPlannerProject.setContentOnModal(response)
            });
    }

    /**
     * Usuwanie projekt i wyświetla modal
     */
    private static deleteSelectedPlannerProject(e) {
        ServiceOpenPlannerProject.setSpinnerOnModal();
        ServiceOpenPlannerProject.modalOn();
        let btn = $(e.target);
        let plannerProjectId = btn.data("planner-project-id");
        ServiceOpenPlannerProject.deletePlannerProject(plannerProjectId)
            .then((response) => {
                ServiceOpenPlannerProject.setContentOnModal(response);
            });
    }

    /**
     * Pobiera modal z potwierdzeniem usunięcia
     */
    private static loadModalConfirmDeleteProject(id) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}load_modal_confirm_delete_projects/`,
            method: 'POST',
            data: {
                id: id
            },
            dataType: 'html',
        })
    }

    /**
     * Wysyła żadanie usunięcia projektu
     */
    private static deletePlannerProject(id) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}delete_planner_project/`,
            method: 'POST',
            data: {
                id: id
            },
            dataType: 'html',
        })
    }

    private static filterPlannerProjects(e) {
        e.preventDefault();
        let searchPhrase = $(PlannerSelectors.MODAL.FIND_PROJECTS.PHRASE).val().toString() as string;
        ServiceOpenPlannerProject.setSpinnerOnModal();
        ServiceOpenPlannerProject.filterPlannerProjectsRequest(searchPhrase)
            .done((response) => {
                ServiceOpenPlannerProject.showModalWithAllUserProjects(response.html);
            });
    }

    private static filterPlannerProjectsRequest(searchPhrase :string) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}filter_planner_projects/`,
            method: 'GET',
            data: {
                searchPhrase: searchPhrase
            },
            dataType: 'json',
        })
    }
}import * as $ from 'jquery';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import {onClick, onSubmit} from 'Core/Events';
import {PlannerSubProcessCommon} from "Components/Planner/PlannerSubProcessCommon";

export class ServiceOpenPlannerProject extends PlannerSubProcessCommon {

    @onClick(PlannerSelectors.MODAL.BACK_TO_PROJECTS_BTN, ServiceOpenPlannerProject.loadAndDisplayUserProjectsModalAfterPageChange)
    @onClick(PlannerSelectors.MODAL.USER_PROJECTS_LIST.LOAD_PROJECT_BTN, ServiceOpenPlannerProject.displayPlannerProject)
    @onClick(PlannerSelectors.MODAL.USER_PROJECTS_LIST.DELETE_PROJECT_BTN, ServiceOpenPlannerProject.loadAndDisplayDeleteModal)
    @onClick(PlannerSelectors.MODAL.USER_PROJECTS_LIST.PAGE_BUTTONS, ServiceOpenPlannerProject.loadAndDisplayUserProjectsModalAfterPageChange)
    @onClick(PlannerSelectors.MODAL.CONFIRM_DELETE_PROJECT_BTN, ServiceOpenPlannerProject.deleteSelectedPlannerProject)
    @onSubmit(PlannerSelectors.MODAL.ASSIGN_PROJECT.FORM, ServiceOpenPlannerProject.assignPlannerProject)
    @onSubmit(PlannerSelectors.MODAL.FIND_PROJECTS.FORM, ServiceOpenPlannerProject.filterPlannerProjects)

    private static netDecor;

    public init(netDecor) {
        ServiceOpenPlannerProject.netDecor = netDecor;
        ServiceOpenPlannerProject.loadAndDisplayUserProjectsModal(1);
    }

    /**
     * Wczytuje i wyświetla modal z projektami usera
     */
    private static loadAndDisplayUserProjectsModal(page) {
        ServiceOpenPlannerProject.getAllUserPlannerProjects(page)
            .done((response) => {
                if (response.status == true) {
                    ServiceOpenPlannerProject.showModalWithAllUserProjects(response.html);
                } else {
                    if($(PlannerSelectors.TOOGLER).length > 0){
                        $(PlannerSelectors.TOOGLER).click();
                    } else {
                        ServiceOpenPlannerProject.loadAndDisplayModalSessionHasExpired();
                        ServiceOpenPlannerProject.emergencyLoadingOfLoginForm()
                            .done(() => {
                                $(PlannerSelectors.TOOGLER).click();
                            })
                    }
                }
            });
    }

    private static loadAndDisplayUserProjectsModalAfterPageChange(e)
    {
        e.preventDefault();
        let page = 1;
        if($(e.target).val().toString().length > 0){
            page = $(e.target).val() as number;
        }

        ServiceOpenPlannerProject.loadAndDisplayUserProjectsModal(page);
    }

    /**
     * Pokazuje modal z projektami usera
     */
    private static showModalWithAllUserProjects(html) {
        ServiceOpenPlannerProject.setSpinnerOnModal();
        ServiceOpenPlannerProject.modalOn();
        ServiceOpenPlannerProject.setContentOnModal(html)
    }

    private static assignPlannerProject(e) {
        e.preventDefault();
        let projectNumber = $(PlannerSelectors.MODAL.ASSIGN_PROJECT.NUMBER).val() as string;
        ServiceOpenPlannerProject.setSpinnerOnModal();
        if(projectNumber.length > 0) {
            ServiceOpenPlannerProject.assignPlannerProjectToAccount(projectNumber)
                .done((response) => {
                    ServiceOpenPlannerProject.showModalWithAllUserProjects(response.html);
                });
        }
    }


    /**
     * Wczytuje modal z projektami usera
     */
    private static getAllUserPlannerProjects(page) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}load_planner_projects/`,
            method: 'GET',
            data: {
                page: page
            },
            dataType: 'json',
        })
    }

    private static assignPlannerProjectToAccount(projectNumber) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}assign_project_to_account/`,
            method: 'GET',
            data: {
                projectNumber: projectNumber
            },
            dataType: 'json',
        })
    }

    /**
     * Wyśweitalnie projektu usera
     */
    private static displayPlannerProject(e) {
        let btn = $(e.target);
        let plannerProjectId = btn.data("planner-project-id");
        let projectData = null;
        ServiceOpenPlannerProject.getPlannerProjectData(plannerProjectId)
            .then(response => {
                projectData = response;
                return ServiceOpenPlannerProject.getPlannerProjectFile(response.project)
            })
            .then(response => {
                ServiceOpenPlannerProject.netDecor.Project.Open(new Uint8Array(response), JSON.stringify({id: projectData.id, name : projectData.projectName}));
            }).then(() => {
                ServiceOpenPlannerProject.modalOff();
        })
    }

    /**
     * Pobiera dane projektu
     */
    private static getPlannerProjectData(projectId) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}get_planner_project_data/`,
            method: 'POST',
            dataType: 'json',
            data: {
                id: projectId
            }
        })
    }

    /**
     * Pobiera plik projektu
     */
    private static getPlannerProjectFile(fileName) {
        var xhrOverride = new XMLHttpRequest();
        xhrOverride.responseType = 'arraybuffer';
        return $.ajax({
            url: window.location.origin + '/dekorator_projects/projects/'+fileName+'?'+Math.random(),
            method: 'GET',
            xhr: function() {
                return xhrOverride;
            }
        })
    }

    /**
     * Pobiera i wyświetla modal usuwanie projektu
     */
    private static loadAndDisplayDeleteModal(e) {
        ServiceOpenPlannerProject.setSpinnerOnModal();
        ServiceOpenPlannerProject.modalOn();
        let btn = $(e.target);
        let plannerProjectId = btn.data("planner-project-id");
        ServiceOpenPlannerProject.loadModalConfirmDeleteProject(plannerProjectId)
            .then((response) => {
                ServiceOpenPlannerProject.setContentOnModal(response)
            });
    }

    /**
     * Usuwanie projekt i wyświetla modal
     */
    private static deleteSelectedPlannerProject(e) {
        ServiceOpenPlannerProject.setSpinnerOnModal();
        ServiceOpenPlannerProject.modalOn();
        let btn = $(e.target);
        let plannerProjectId = btn.data("planner-project-id");
        ServiceOpenPlannerProject.deletePlannerProject(plannerProjectId)
            .then((response) => {
                ServiceOpenPlannerProject.setContentOnModal(response);
            });
    }

    /**
     * Pobiera modal z potwierdzeniem usunięcia
     */
    private static loadModalConfirmDeleteProject(id) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}load_modal_confirm_delete_projects/`,
            method: 'POST',
            data: {
                id: id
            },
            dataType: 'html',
        })
    }

    /**
     * Wysyła żadanie usunięcia projektu
     */
    private static deletePlannerProject(id) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}delete_planner_project/`,
            method: 'POST',
            data: {
                id: id
            },
            dataType: 'html',
        })
    }

    private static filterPlannerProjects(e) {
        e.preventDefault();
        let searchPhrase = $(PlannerSelectors.MODAL.FIND_PROJECTS.PHRASE).val().toString() as string;
        ServiceOpenPlannerProject.setSpinnerOnModal();
        ServiceOpenPlannerProject.filterPlannerProjectsRequest(searchPhrase)
            .done((response) => {
                ServiceOpenPlannerProject.showModalWithAllUserProjects(response.html);
            });
    }

    private static filterPlannerProjectsRequest(searchPhrase :string) {
        return $.ajax({
            url: `${ServiceOpenPlannerProject.ajaxUrl}filter_planner_projects/`,
            method: 'GET',
            data: {
                searchPhrase: searchPhrase
            },
            dataType: 'json',
        })
    }
}